export default __webpack_public_path__ + "preview-smart-upload.1694dea3.svg";